import {Dispatch} from '@reduxjs/toolkit';
import {
  setTemplateMeta,
  setTemplateMapping,
  setOriginalMapping,
  setIsSupportMapping,
  setIsPlatformMapping,
  setIsAllowedToUpdateProductCount,
  setIsSupportMappingTimeline,
  setIsV9,
  setCompletedFormats,
  setFormatsChanged,
  setFormatsProductCountChanged,
  setIsOfflinePreview,
  setSourceTypeFilter,
  setSupportedDynamicSourceTypes,
} from '../templateMapping.slice';
import {
  CreativeTemplateType,
  Format,
} from 'common/src/modules/creativeTemplates/creativeTemplates.types';
import {getFormatKey} from 'common/src/components/PreviewPanelComponents/utils/getFormatKey';
import isMappingSupportedTemplate from 'common/src/modules/creativeTemplates/utils/isMappingSupportedTemplate';
import {videoPoweredTemplateTypes} from 'common/src/modules/creativeTemplates/creativeTemplates.consts';
import _isEmpty from 'lodash/isEmpty';
import {DPMeta, DPLayerMapping} from 'common/src/modules/dynamicParameters/dynamicParameters.types';
import {CreativeTemplate} from 'common/src/modules/creativeTemplates/creativeTemplates.types';
import getTemplateSupportedSources from 'common/src/modules/creativeTemplates/utils/getTemplateSupportedSources';

interface InitialLoadParams {
  template: CreativeTemplate;
  templateMeta: Record<string, DPMeta>;
  templateMapping: Record<string, DPLayerMapping[]>;
}

export default function initialLoadTemplateMappingData(
  dispatch: Dispatch,
  {template, templateMeta, templateMapping}: InitialLoadParams,
): void {
  // Set completed formats
  const completedFormats = Object.fromEntries(
    template.formats.map((f: Format) => [
      getFormatKey({w: f.format.Width, h: f.format.Height}),
      false,
    ]),
  );
  dispatch(setCompletedFormats(completedFormats));

  // Set support mapping timeline
  const isSupportMappingTimeline =
    [CreativeTemplateType.DisplayAds, CreativeTemplateType.InBannerVideoAds].includes(
      template?.type,
    ) ||
    (videoPoweredTemplateTypes.includes(template?.type) && false); // isOfflinePreview will be set separately

  // Set the core mapping data
  dispatch(setTemplateMeta(templateMeta));
  dispatch(setTemplateMapping(templateMapping));
  dispatch(setOriginalMapping(templateMapping));
  // Set template mapping properties
  dispatch(setIsSupportMapping(isMappingSupportedTemplate(template.source)));
  dispatch(setIsPlatformMapping(isMappingSupportedTemplate(template.source)));
  dispatch(setIsV9(template.formats.some((f: Format) => f.RendererVersion <= 9)));

  dispatch(
    setIsAllowedToUpdateProductCount(
      !template.creativeIdInActiveCampaigns || _isEmpty(template.creativeIdInActiveCampaigns),
    ),
  );
  dispatch(setFormatsChanged([]));
  dispatch(setFormatsProductCountChanged([]));
  dispatch(setSupportedDynamicSourceTypes(getTemplateSupportedSources(template)));
  dispatch(setIsSupportMappingTimeline(isSupportMappingTimeline));
  dispatch(setIsOfflinePreview(false));
  dispatch(setSourceTypeFilter(null));
}
